import Vue from 'vue';
import {mapActions, mapState} from 'vuex';
import {ClubLocationsModuleConstant} from '../../lib/constants';
import MemberSearchChiclets from './memberSearchChiclets.html';
import EcCommon from '../../../types/ec/ecCommon';

export default Vue.component('ecMemberSearchChiclets', {
	template: MemberSearchChiclets,
	computed: {
		...mapState(ClubLocationsModuleConstant.name, [ClubLocationsModuleConstant.state.selectedClubs]),
	},
	methods: {
		clearFilters(): void {
			this.unSelectAllClubs();
		},
		stateChanged(club: EcCommon.IClub): void {
			const data = {...club};
			data.Selected = false;
			this.unSelectClub(data);
		},
		...mapActions(ClubLocationsModuleConstant.name, [
			ClubLocationsModuleConstant.action.unSelectClub,
			ClubLocationsModuleConstant.action.unSelectAllClubs
		]),
	},
});
